<template>
  <div>
    <el-alert
      title="审核后增加现存量并写库存流水，弃审再扣回。明细可选库位、批次和托盘。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.stockInCode" clearable placeholder="入库单号" style="width:170px" @keyup.enter.native="search" />
      <el-select v-model="query.approveStatus" clearable placeholder="审核状态" style="width:120px">
        <el-option label="未审核" value="0" />
        <el-option label="已审核" value="2" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="stockInCode" label="入库单号" width="180" />
      <el-table-column prop="stockInDate" label="入库日期" width="120" />
      <el-table-column prop="totalQuantity" label="合计数量" width="110" align="right" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.approveStatus === '2' ? 'success' : 'info'">{{ row.approveStatus === '2' ? '已审核' : '未审核' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createByName" label="制单人" width="100" />
      <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip />
      <el-table-column label="操作" width="260" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openView(row.stockInId)">查看</el-button>
          <el-button type="text" :disabled="row.approveStatus !== '0'" @click="openEdit(row.stockInId)">修改</el-button>
          <el-button type="text" :disabled="row.approveStatus !== '0'" @click="approveRow(row.stockInId)">审核</el-button>
          <el-button type="text" :disabled="row.approveStatus !== '2'" @click="unapproveRow(row.stockInId)">弃审</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.approveStatus !== '0'" @click="onDelete(row.stockInId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="dialogTitle" :visible.sync="visible" width="1180px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="12"><el-form-item label="入库单号"><el-input v-model="form.stockInCode" placeholder="留空自动生成" /></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="入库日期">
              <el-date-picker v-model="form.stockInDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item></el-col>
        </el-row>
        <el-button v-if="!readonly" type="primary" size="mini" @click="addLine">添加明细</el-button>
        <el-table :data="form.lineList" border size="small" style="margin-top:8px">
          <el-table-column label="产品" min-width="220">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ productLabel(row) }}</span>
              <el-select v-else v-model="row.productId" filterable size="mini" style="width:100%">
                <el-option v-for="p in products" :key="p.productId" :label="p.productNumber + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="仓库" width="160">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.wareHouseName || wareHouseLabel(row.wareHouseId) }}</span>
              <el-select v-else v-model="row.wareHouseId" filterable size="mini" placeholder="选择仓库" style="width:100%" @change="onWhChange(row)">
                <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="库位" width="140">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ areaLabel(row) }}</span>
              <el-select v-else v-model="row.wareAreaId" filterable clearable size="mini" placeholder="可选" style="width:100%" @focus="loadAreas(row.wareHouseId)">
                <el-option v-for="a in areasOf(row)" :key="a.wareAreaId" :label="a.wareAreaName" :value="a.wareAreaId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="批次" width="110">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.batchNo || '-' }}</span>
              <el-input v-else v-model="row.batchNo" size="mini" placeholder="可选" />
            </template>
          </el-table-column>
          <el-table-column label="托盘" width="140">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ palletLabel(row.palletId) }}</span>
              <el-select v-else v-model="row.palletId" filterable clearable size="mini" placeholder="可选" style="width:100%">
                <el-option v-for="p in pallets" :key="p.palletId" :label="p.palletCode + (p.palletName ? ' / ' + p.palletName : '')" :value="p.palletId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="140">
            <template slot-scope="{ row }">
              <span v-if="readonly">{{ row.quantity }}</span>
              <el-input-number v-else v-model="row.quantity" :min="0" :precision="5" size="mini" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column v-if="!readonly" label="操作" width="70" align="center">
            <template slot-scope="{ $index }">
              <el-button type="text" size="mini" @click="form.lineList.splice($index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!readonly" type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listOtherIn, getOtherIn, saveOtherIn, updateOtherIn, deleteOtherIn, approveOtherIn, unapproveOtherIn } from '../../api/otherIn'
import { selectEnabledWareHouse, listWareArea } from '../../api/warehouse'
import { selectProduct } from '../../api/product'
import { selectPallet } from '../../api/pallet'

function emptyForm() {
  return {
    stockInId: '', stockInCode: '', stockInDate: null, stockInType: '0', remark: '',
    lineList: [{ productId: '', wareHouseId: '', wareAreaId: '', batchNo: '', palletId: '', quantity: 1 }]
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { stockInCode: '', approveStatus: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false, readonly: false,
      form: emptyForm(), products: [], warehouses: [], pallets: [], areaMap: {}
    }
  },
  created() {
    this.load()
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
    selectPallet().then(res => { this.pallets = res.data || [] }).catch(() => {})
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看其他入库'
      return this.form.stockInId ? '修改其他入库' : '新增其他入库'
    }
  },
  methods: {
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listOtherIn({
        currentPage: this.page, pageSize: this.pageSize,
        stockInCode: this.query.stockInCode, approveStatus: this.query.approveStatus
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    addLine() { this.form.lineList.push({ productId: '', wareHouseId: '', wareAreaId: '', batchNo: '', palletId: '', quantity: 1 }) },
    onWhChange(row) {
      row.wareAreaId = ''
      this.loadAreas(row.wareHouseId)
    },
    areasOf(row) { return this.areaMap[row.wareHouseId] || [] },
    loadAreas(wareHouseId) {
      if (!wareHouseId || this.areaMap[wareHouseId]) return
      listWareArea({ wareHouseId, pageSize: 200 }).then(res => {
        const list = ((res.data && res.data.list) || []).filter(a => a.type === '1')
        this.$set(this.areaMap, wareHouseId, list)
      }).catch(() => {})
    },
    productLabel(row) {
      if (row.productNumber || row.productName) {
        return (row.productNumber || '') + (row.productName ? ' / ' + row.productName : '')
      }
      const p = (this.products || []).find(x => x.productId === row.productId)
      if (p) return (p.productNumber || '') + (p.productName ? ' / ' + p.productName : '')
      return row.productId || '-'
    },
    wareHouseLabel(id) {
      if (!id) return '-'
      const w = (this.warehouses || []).find(x => x.wareHouseId === id)
      return w ? w.wareHouseName : id
    },
    areaLabel(row) {
      if (!row.wareAreaId) return '-'
      const a = (this.areasOf(row) || []).find(x => x.wareAreaId === row.wareAreaId)
      return a ? a.wareAreaName : row.wareAreaId
    },
    palletLabel(id) {
      if (!id) return '-'
      const p = (this.pallets || []).find(x => x.palletId === id)
      return p ? (p.palletCode + (p.palletName ? ' / ' + p.palletName : '')) : id
    },
    openView(id) { this.loadDetail(id, true) },
    openEdit(id) {
      if (!id) {
        this.readonly = false
        this.form = emptyForm()
        this.visible = true
        return
      }
      this.loadDetail(id, false)
    },
    loadDetail(id, readonly) {
      getOtherIn(id).then(res => {
        const d = res.data || {}
        this.readonly = !!readonly
        this.form = {
          stockInId: d.stockInId, stockInCode: d.stockInCode, stockInDate: d.stockInDate,
          stockInType: d.stockInType || '0', remark: d.remark || '',
          lineList: (d.lineList && d.lineList.length) ? d.lineList.map(l => ({
            productId: l.productId, wareHouseId: l.wareHouseId,
            productNumber: l.materialCode || '', productName: l.materialName || '',
            wareHouseName: l.wareHouseName || '',
            wareAreaId: l.wareAreaId || '', batchNo: l.batchNo || '', palletId: l.palletId || '',
            quantity: Number(l.quantity)
          })) : []
        }
        this.form.lineList.forEach(l => this.loadAreas(l.wareHouseId))
        this.visible = true
      })
    },
    submit() {
      const lines = (this.form.lineList || []).filter(l => l.productId && Number(l.quantity) > 0)
      if (!lines.length) { this.$message.warning('请添加物料明细'); return }
      if (lines.some(l => !l.wareHouseId)) { this.$message.warning('请选择仓库'); return }
      this.saving = true
      const payload = { ...this.form, lineList: lines }
      const req = this.form.stockInId ? updateOtherIn(payload) : saveOtherIn(payload)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    approveRow(id) {
      this.$confirm('审核后将增加库存，确定继续?', '提示', { type: 'warning' }).then(() => {
        approveOtherIn(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    unapproveRow(id) {
      this.$confirm('弃审将扣减库存，确定继续?', '提示', { type: 'warning' }).then(() => {
        unapproveOtherIn(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteOtherIn([id]).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
